import { getApiUrl } from "@/constants";
import httpClient from "@/dataprovider/http-client";
import {
  isEventRelayAccessSyncPreviewResult,
  type EventRelayAccessSyncPreviewResult,
  type EventRelayAccessSyncResponse,
} from "@/containers/events/types";

export async function fetchEventRelayAccessSyncPreview(
  eventId: string
): Promise<EventRelayAccessSyncPreviewResult> {
  const { json } = await httpClient(
    `${getApiUrl()}/events/${encodeURIComponent(eventId)}/relay-access/sync-preview`,
    { method: "GET" }
  );
  if (!isEventRelayAccessSyncPreviewResult(json)) {
    throw new Error("Unexpected sync preview response");
  }
  return json;
}

export async function syncEventRelayAccess(
  eventId: string,
  rows: Array<{ itsId: string; action: "create" | "revoke" | "update_reason" }>
): Promise<EventRelayAccessSyncResponse> {
  const { json } = await httpClient(
    `${getApiUrl()}/events/${encodeURIComponent(eventId)}/relay-access/sync`,
    {
      method: "POST",
      body: JSON.stringify({ rows }),
    }
  );
  if (json == null || typeof json !== "object") {
    throw new Error("Unexpected sync response");
  }
  const payload = json as EventRelayAccessSyncResponse;
  if (!Array.isArray(payload.results) || !isEventRelayAccessSyncPreviewResult(payload.preview)) {
    throw new Error("Unexpected sync response");
  }
  return payload;
}
